<div mat-dialog-title class="title">
    <span class="heading">Client To Bills Transfer</span>
    <button (click)="closeDialog()" mat-dialog-close class="close-button" mat-icon-button matSuffix>
        <mat-icon class="close-icon-color">cancel</mat-icon>
    </button>
</div>
<div class="wrapper">
    <div class="form-container">
        <form [formGroup]="transferRequestForm">
            <mat-form-field class="fullLength" *ngIf="showReturnReason">
                <mat-label style="color: red;">Rejected Reason</mat-label>
                <input matInput formControlName="returnReason" readonly>
            </mat-form-field>
            <div class="search">
                <mat-form-field class="halfLength">
                    <mat-label>Matter</mat-label>

                    <input matInput
                           formControlName="matter"
                           [matAutocomplete]="auto" />
                    <mat-error>Please select a matter.</mat-error>
                </mat-form-field>
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngIf="isLoading">
                        Loading....
                    </mat-option>
                    <mat-option *ngIf="noData && !isLoading">
                        No matching matters found.
                    </mat-option>
                    <div *ngIf="!isLoading && !noData">
                        <mat-option *ngFor="let item of matterDropdownData"
                                    [value]="displayMatter(item)">
                            {{ item.number }} - {{ item.description }}
                        </mat-option>
                    </div>
                </mat-autocomplete>

                <mat-form-field class="halfLength">
                    <mat-label>Client Name</mat-label>
                    <input matInput formControlName="client" readonly />
                    <mat-progress-spinner *ngIf="isLoading"
                                          class="spinner-padding"
                                          matSuffix
                                          mode="indeterminate"
                                          diameter="20"
                                          strokeWidth="3"
                                          color="accent">
                    </mat-progress-spinner>
                </mat-form-field>
            </div>

            @if (showLinkToOpenMatter()) {
            <div class="sticky-actionstep-bar">
                <div class="link-wrapper">
                    <a [href]="actionstepMatterUrl"
                       target="_blank"
                       rel="noopener noreferrer">
                        Open Matter in Actionstep ({{ matterNo }})
                    </a>
                    <button mat-icon-button
                            class="small-copy-btn"
                            [cdkCopyToClipboard]="actionstepMatterUrl"
                            (cdkCopyToClipboardCopied)="onUrlCopied()"
                            matTooltip="Copy link to clipboard"
                            matTooltipPosition="below">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
                <div class="warning-box">
                    You must be logged into Actionstep under the same jurisdiction.
                </div>
            </div>
            }

            <div class="search">
                @if(showDateTransaction()){
                <div class="date-time-row">
                    <mat-form-field color="accent" class="date-field">
                        <mat-label>Transaction Date</mat-label>
                        <input matInput [matDatepicker]="transactionDatePicker" formControlName="dateTransaction" />
                        <mat-datepicker-toggle matSuffix [for]="transactionDatePicker" />
                        <mat-datepicker #transactionDatePicker />
                        @if (transferRequestForm.get('dateTransaction')?.touched && transferRequestForm.get('dateTransaction')?.invalid) {
                        <mat-error>Please select a date.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field color="accent" class="time-field">
                        <mat-label>Transaction Time</mat-label>
                        <input matInput
                               type="time"
                               formControlName="transactionTime" />
                    </mat-form-field>
                </div>
                }
                <mat-form-field class="w-100">
                    <mat-label>Client Bank</mat-label>
                    <mat-select formControlName="clientBankAccount">
                        <mat-option *ngFor="let account of filteredBankAccounts" [value]="account">
                            {{ account.accountId }} - {{ account.description }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>



            @if (showLinkToOpenMatter()) {
            <div class="actionstep-matter-overview">
                <div class="link-wrapper">
                    <a [href]="actionstepMatterOverviewUrl"
                       target="_blank"
                       rel="noopener noreferrer">
                        Open Actionstep Matter ({{ matterNo }}) Overview to view linked accounts
                    </a>
                    <button type="button" mat-icon-button
                            class="small-copy-btn"
                            [cdkCopyToClipboard]="actionstepMatterOverviewUrl"
                            (cdkCopyToClipboardCopied)="onUrlCopied()"
                            matTooltip="Copy link to clipboard"
                            matTooltipPosition="below">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
                <div class="warning-box">
                    You must be logged into Actionstep under the same jurisdiction.
                </div>
            </div>
            }

            <mat-form-field class="fullLength">
                <mat-label>Reason for transfer</mat-label>
                <textarea matInput formControlName="reason" (input)="onReasonInput()"></textarea>
                <mat-error *ngIf="transferRequestForm.get('reason')?.hasError('required')">
                    Reason for transfer is required when selecting No.
                </mat-error>
            </mat-form-field>

            <div class="search">
                <div class="date-time-row">
                    <mat-form-field color="accent" class="date-field">
                        <mat-label>Requested Date</mat-label>
                        <input matInput [matDatepicker]="requestedDatePicker" formControlName="dateRequested" placeholder="dd/MM/yyyy" [max]="currentDate"/>
                        <mat-datepicker-toggle matSuffix [for]="requestedDatePicker" />
                        <mat-datepicker #requestedDatePicker />
                        @if (transferRequestForm.get('dateRequested')?.touched && transferRequestForm.get('dateRequested')?.invalid) {
                        <mat-error>Please select a date.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field color="accent" class="time-field">
                        <mat-label>Requested Time</mat-label>
                        <input matInput type="time" formControlName="requestedTime" placeholder="HH:mm" />
                        @if (transferRequestForm.get('requestedTime')?.touched && transferRequestForm.get('requestedTime')?.invalid) {
                        <mat-error>Please enter a time.</mat-error>
                        }
                    </mat-form-field>
                </div>

                <mat-form-field class="halfLength">
                    <mat-label>Payment method</mat-label>
                    <mat-select formControlName="paymentMethod">
                        <mat-option *ngFor="let method of paymentMethodDropdown"
                                    [value]="method">
                            {{method}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            @if (isTransactionDetailsVisible) {
            <div class="search">
                <mat-form-field class="halfLength">
                    <mat-label>Transaction reference</mat-label>
                    <input matInput formControlName="transactionReference">
                </mat-form-field>

                <mat-form-field class="halfLength">
                    <mat-label>Deposit Account</mat-label>
                    <input readonly matInput formControlName="depositAccount" />
                </mat-form-field>
            </div>
            }

            <div class="form">
                <mat-table [dataSource]="bills" *ngIf="bills.length > 0" class="fullLength">
                    <ng-container matColumnDef="pay">
                        <mat-header-cell *matHeaderCellDef> Action Step Balance </mat-header-cell>
                        <mat-cell *matCellDef="let bill">
                            Invoice #{{ bill.ourReference }}
                            (Balance Due: {{ currencySymbol }}{{ bill.totalDue }})
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="warning">
                        <mat-header-cell *matHeaderCellDef> Eligible Payment Amount </mat-header-cell>
                        <mat-cell *matCellDef="let bill">
                            @if (invoiceMap[bill.ourReference]; as invoiceData) {
                            <div class="warning-box">
                                Current Balance for Invoice #{{ bill.ourReference }} is
                                ({{ currencySymbol }}{{ (bill.totalDue - invoiceData.totalAmount) | number:'1.2-2' }})
                            </div>
                            }
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="amount">
                        <mat-header-cell *matHeaderCellDef> Amount </mat-header-cell>
                        <mat-cell *matCellDef="let bill" class="amount-cell">
                            <mat-form-field class="amountField">
                                <input type="text" matInput [formControlName]="getControlName(bill)"
                                       (keydown)="validateInput($event)" appCurrencyInput>
                                <mat-error *ngIf="true">
                                    The entered amount exceeds the total due amount.
                                </mat-error>
                            </mat-form-field>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
            </div>

            <div class="amount-row" *ngIf="bills.length > 0">
                <div class="total-amout">Total Amount</div>
                <mat-form-field class="amout">
                    <input type="text" matInput maxlength="12" formControlName="amount" appCurrencyInput />
                </mat-form-field>
            </div>
            <div *ngIf="noBillsFoundMessage" class="no-bills-message">
                {{ noBillsFoundMessage }}
            </div>
        </form>
    </div>
</div>

<div class="action-button" mat-dialog-actions>
    <button mat-raised-button color="accent" type="submit" (click)="delete()" [disabled]="isRejectDisabled">
        Reject
    </button>
    <button mat-raised-button color="accent" type="submit" (click)="withdrawTransfer()" [disabled]="isWithdrawDisabled">
        Withdraw Transfer Fund
    </button>
    <button mat-raised-button color="accent" type="submit" (click)="approveRequest()" [disabled]="isDisabled || transferRequestForm.invalid || transferRequestForm.get('amount')?.value <= 0">
        Submit
    </button>
</div>
